<template>
    <div class="uberall-hours-indicator">
      <i class="fas fa-circle"></i> Currently Open
    </div>
</template>

<script>
export default {
    props: ['uberallId'],
    created() {
        if(!this.uberallId) return;
        this.$api = axios.create({
            baseURL: '/wp-json/uberall/v1/',
            headers: { 'X-WP-Nonce': window.DRAEGER.nonce },
            withCredentials: true,
        })

        this.$api.get(`/locations/${this.uberallId}/pub`).then(response => {
            console.log(response.data)
        })
    }
}
</script>

<style lang="scss">
.uberall-hours-indicator {
    font-size: 1rem;
    font-weight: bold;

    i {
        font-size: 0.8rem;
    }
}
</style>